import React, { Fragment } from 'react'
import Showcase from 'Catalog/Showcase'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

const ShowcaseByContext = ({ showcaseType, identifier, identifierCash, isOnlyCash, viewAll }) => {
  const getIdentifier = (identifier, identifierCash, isOnlyCash) => {
    if (isOnlyCash) {
      return identifierCash
    } else {
      return identifier
    }
  }
  return (
    <Fragment>
      <Showcase showcaseType={showcaseType} identifier={getIdentifier(identifier, identifierCash, isOnlyCash)} viewAll={viewAll} />
    </Fragment>
  )
}

ShowcaseByContext.propTypes = {
  showcaseType: PropTypes.string.isRequired,
  identifier: PropTypes.string.isRequired,
  identifierCash: PropTypes.string.isRequired,
  isOnlyCash: PropTypes.bool,
  viewAll: PropTypes.string
}

const mapStateToProps = ({ onlyCash: isOnlyCash }) => {
  return ({
    isOnlyCash
  })
}

export default connect(mapStateToProps)(ShowcaseByContext)



// WEBPACK FOOTER //
// ./src/Catalog/Showcase/ShowcaseByContext.js